import { useQuery } from "@tanstack/react-query";

import { apiGet, type InboxItemList } from "@/lib/api";

export interface InboxQueryParams {
  source_ids?: string[];
  item_types?: string[];
  /** Single-status filter passed to the backend. When omitted, the backend
   *  returns every status (including archived + ignore). The page layer
   *  handles "hide archived/ignore by default" by filtering client-side,
   *  because the backend only accepts a single status. */
  status?: string;
  symbol?: string;
  since?: string;
  until?: string;
  time_basis?: "captured" | "source";
  limit?: number;
  offset?: number;
}

async function fetchInbox(p: InboxQueryParams): Promise<InboxItemList> {
  return apiGet<InboxItemList>("/api/v1/inbox", {
    source_id: p.source_ids,
    item_type: p.item_types,
    status: p.status,
    symbol: p.symbol,
    since: p.since,
    until: p.until,
    time_basis: p.time_basis,
    limit: p.limit,
    offset: p.offset,
  });
}

export function useInbox(params: InboxQueryParams) {
  return useQuery<InboxItemList>({
    queryKey: ["inbox", params],
    queryFn: () => fetchInbox(params),
    placeholderData: (prev) => prev,
    refetchInterval: 30_000,
  });
}
